import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Rodal from "rodal";
import assignNew from "../../../../utils/Functions/AssignNew";
import assign from "../../../../utils/Functions/AssignObj";
import UpdateArray from "../../../../utils/Functions/UpdateArray";
import UpdateWidget from "../../../../utils/UpdateWidget";
import Button from "../../../Button/Button";
import SuccessModal from "../Nip-Doc-Upload/SuccessModal";

export const submitDocsFunc = (state, id, submitValues) => {
  const type = "update";
    let allFiles = [];
    const data = state.allResult;
    assign(data, allFiles);
    const files = {
      application_id: id,
      document: allFiles,
    };
    submitValues(files, type);

    return 'success';
}

export const handleDataFetchFunc = (setState, fileResult, newDocArray) => {
  let allResult = newDocArray;
    setState({
      allResult,
    });
    UpdateArray(allResult, fileResult);
    setState({ allResult });
    return 'success';
}

const UpdateDocs = (props) => {
  const {
    success,
    submitValues,
    isSubmitting,
    id,
    uploadedFiles,
    getSingleApplication,
    documents,
  } = props;

  const [state, setState] = useState({
    openModal: false,
    fileResult: {},
    allResult: [],
    errorMessage: "",
    items: [],
    document: [],
    inputValue: "",
  });

  const [modal, setModal] = useState({
    visible: false,
  });

  documents &&
    documents.forEach((el) => {
      const result =
        uploadedFiles &&
        uploadedFiles.findIndex((x) => x.request_document_id === el.id);
      if (result >= 0) {
        el.loaded = true;
        el.url = uploadedFiles && uploadedFiles[result].request_document_url;
      } else {
        el.loaded = false;
        el.url = "";
      }
    });

  const newDocArray = [];
  assignNew(uploadedFiles, newDocArray);

  function handleDataFetch(fileResult) {
    handleDataFetchFunc(setState, fileResult, newDocArray)
  }

  const handleRemoval = (fileResult) => {
    state.allResult &&
      state.allResult.splice(
        state.allResult.findIndex((item) => item.id === fileResult.id),
        1
      );
  };

  const submitDocs = () => {
    submitDocsFunc(state, id, submitValues)
  };

  useEffect(() => {
    if (success) {
      setModal({ ...modal, visible: true });
    }
    // eslint-disable-next-line
  }, [success, setModal]);

  const hide = () => {
    setModal({ ...modal, visible: false });
    getSingleApplication();
  };

  return (
    <div>
      <div className="nip-integration-header">Document Upload</div>
      <div className="doc-upload-integration">
        {documents && documents.length > 0 ? (
          documents.map((item) => (
            <UpdateWidget
              id={item.id}
              key={item.name}
              loaded={item.loaded}
              title={item.title}
              url={item.url}
              handleDataFetch={handleDataFetch}
              name={item.name}
              handleRemoval={handleRemoval}
            />
          ))
        ) : (
          <div className="nip-error">
            <p>Error fetching required documents</p>
          </div>
        )}
      </div>

      <div className="doc-upload-button">
        {documents && documents.length > 0 && (
          <Button
            type="submit"
            width="50%"
            height="50px"
            text="SUBMIT"
            testId="submitApp"
            disabled={state.allResult.length !== 2 || isSubmitting}
            onClick={() => submitDocs()}
          />
        )}

        <Rodal
          width={Number("520")}
          height={Number("480")}
          visible={modal.visible}
        >
          <SuccessModal hide={() => hide()} />
        </Rodal>
      </div>
    </div>
  );
};

UpdateDocs.propTypes = {
  documents: PropTypes.shape({
    forEach: PropTypes.func,
    length: PropTypes.number,
    map: PropTypes.func
  }),
  getSingleApplication: PropTypes.func,
  id: PropTypes.any,
  isSubmitting: PropTypes.any,
  submitValues: PropTypes.func,
  success: PropTypes.any,
  uploadedFiles: PropTypes.shape({
    findIndex: PropTypes.func
  })
}

export default UpdateDocs;
